// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});



(function () {
  function initTatwaReadMore() {
    var desc = document.querySelector('.rich-text__text.rte.section-blocks__subheading');
    if (!desc) return;
    if (desc.dataset.tatwaReadmoreInit === '1') return;

    desc.dataset.tatwaReadmoreInit = '1';

    var collapsedHeight = window.innerWidth < 750 ? 320 : 520;
    var fullHeight = desc.scrollHeight;

    if (fullHeight <= collapsedHeight + 20) return;

    desc.style.position = 'relative';
    desc.style.overflow = 'hidden';
    desc.style.maxHeight = collapsedHeight + 'px';
    desc.style.transition = 'max-height 0.35s ease';

    function applyFade() {
      desc.style.webkitMaskImage = 'linear-gradient(to bottom, black 0%, black 72%, transparent 100%)';
      desc.style.maskImage = 'linear-gradient(to bottom, black 0%, black 72%, transparent 100%)';
      desc.style.webkitMaskRepeat = 'no-repeat';
      desc.style.maskRepeat = 'no-repeat';
      desc.style.webkitMaskSize = '100% 100%';
      desc.style.maskSize = '100% 100%';
    }

    function removeFade() {
      desc.style.webkitMaskImage = 'none';
      desc.style.maskImage = 'none';
    }

    applyFade();

    var wrap = document.createElement('div');
    wrap.className = 'tatwa-readmore-wrap';

    var moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'tatwa-readmore-btn';
    moreBtn.textContent = 'Lire la suite';

    var lessBtn = document.createElement('button');
    lessBtn.type = 'button';
    lessBtn.className = 'tatwa-readmore-btn';
    lessBtn.textContent = 'Réduire';
    lessBtn.style.display = 'none';

    wrap.appendChild(moreBtn);
    wrap.appendChild(lessBtn);
    desc.insertAdjacentElement('afterend', wrap);

    moreBtn.addEventListener('click', function () {
      desc.style.maxHeight = (fullHeight + 120) + 'px';
      moreBtn.style.display = 'none';
      lessBtn.style.display = 'inline-block';
      removeFade();
    });

    lessBtn.addEventListener('click', function () {
      desc.style.maxHeight = collapsedHeight + 'px';
      lessBtn.style.display = 'none';
      moreBtn.style.display = 'inline-block';
      applyFade();
      desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function launchTatwaReadMore() {
    initTatwaReadMore();
    setTimeout(initTatwaReadMore, 300);
    setTimeout(initTatwaReadMore, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', launchTatwaReadMore);
  } else {
    launchTatwaReadMore();
  }
})();